import { TableSettings } from './types';
import { Theme } from '../../../themeBase';
const commonRowSettings = {
  paddingLeft: 7,
  paddingRight: 7,
  border: 0,
  borderTop: 1,
  borderColor: 'gray.extraLight',
  borderStyle: 'solid',
  background: 'white.main',
};

export const tableSettings: TableSettings = {
  componentVariants: {
    cell: {
      prop: 'cellSize',
      variants: {
        regular: {
          paddingTop: 4,
          paddingBottom: 4,
        },
      },
    },
    header: {
      prop: 'variant',
      variants: {
        primary: {
          backgroundColor: 'white.main',
          color: 'primary.extraDark',
          fontWeight: 2,
          fill: 'primary.extraDark',
        },
        secondary: {
          backgroundColor: 'primary.dark',
          color: 'white.main',
          fontWeight: 2,
          fill: 'white.main',
        },
      },
    },
    table: {
      prop: 'size',
      variants: {
        regular: {
          fontFamily: 'secondary',
          fontSize: 1,
          lineHeight: 1,
        },
      },
    },
    row: {
      prop: 'variant',
      variants: {
        body: {
          ...commonRowSettings,
          '&:hover': {
            backgroundColor: 'primary.extraLight',
          },
        },
        head: {
          ...commonRowSettings,
        },
      },
    },
    footer: {
      prop: 'variant',
      variants: {
        default: {
          background: 'primary.extraLight',
        },
      },
    },
    wrapper: {
      prop: 'wrapper',
      variants: {
        default: {
          borderRadius: 3,
          boxShadow: (props: Theme) =>
            `0px 12px 24px 0px ${props.colors.gray.extraLight}`,
        },
      },
    },
  },
};
